import type { SvgName } from '@ingenico/react-ui/svg-asset';

export enum LogicalDeviceConnectivityIconColor {
  Succes = 'success',
  Mid = 'warning',
  Low = 'error',
  Inherit = 'inherit',
}

type AllowedIcons =
  | 'bluetooth'
  | 'setting-ethernet'
  | 'signal-celular-low'
  | 'signal-celular-mid'
  | 'signal-celular'
  | 'sim-card'
  | 'wifi';

export interface LogicalDeviceConnectivityInfoParams {
  readonly icon: Extract<AllowedIcons, SvgName>;
  readonly label: string;
  readonly iconColor?: LogicalDeviceConnectivityIconColor;
  readonly tooltip?: string;
  readonly key?: string;
  readonly containerClassName?: string;
  readonly strength?: 'EXCELLENT' | 'GOOD' | 'POOR' | undefined;
  readonly subtitle?: string;
}
